<ng-container *transloco="let t">

  <div class="gallery" *ngIf="images">

    <!-- LABELS -->
    <div class="product-labels stack stack-vertical stack-4" *ngIf="labels">
      <raf-product-label *ngFor="let label of labels" [label]="label"></raf-product-label>
    </div>

    <!-- Preview (actual image) -->
    <swiper class="gallery-main-image-swiper" [slidesPerView]="1"
            [threshold]="5"
            [thumbs]="{ swiper: thumbSwiper }"
            [pagination]="{type: 'fraction'}"
            [navigation]="true"
            (activeIndexChange)="onSlideChange($event)">
      <ng-template swiperSlide *ngFor="let image of thumbnails$ | async" let-data>
        <raf-image [fixedContainerSize]="false" class="gallery-main-image"  (click)="maximizeImage($event)"
                   [attr.data-cy]="(image$ | async) === image ? 'preview' : ''"
                   [fromB2c]="image" targetQuality="high" [alternativeText]="alternativeText"></raf-image>
      </ng-template>


      <ng-template class="slide-placeholder" swiperSlide *ngIf="!(thumbnails$ | async)?.length">
        <div class="image-placeholder"></div>
      </ng-template>
    </swiper>

    <span class="gallery-label mr-3">{{ t("PRODUCT_DETAIL.GALLERY_DESCRIPTION") }}</span>

    <!-- Thumbnails -->
    <swiper
      data-cy="thumbnails"
      *ngIf="images.length > 1 && (isMobile$ | async) !== true"
      (swiper)="onThumbSwiperInit($event)"
      [spaceBetween]="10"
      [slidesPerView]="6"
      [threshold]="5"
      class="gallery-thumbnails"
    >
      <ng-template swiperSlide *ngFor="let image of thumbnails$ | async; let idx = index">
        <raf-image [fixedContainerSize]="false" [withBorder]="true" class="gallery-thumbnail" data-cy="thumbnail" [fromB2c]="image"
                   targetQuality="preview" [alternativeText]="alternativeText"></raf-image>
      </ng-template>
    </swiper>
  </div>

</ng-container>
